module.exports = __webpack_public_path__ + "img/13e1fe8.jpeg";